import { useEmployee } from "@/contexts/EmployeeProvider.tsx";
import { useFetchPendingLeads } from "@/queries/useFetchPendingLeads.ts";
import { SLA_HOURS, isOverSla } from "@/utils/pendingIntakeSla.ts";
import { Chip, Tooltip } from "@mui/material";
import { TriangleAlert } from "lucide-react";
import type { ReactNode } from "react";

const PendingIntakeSlaBadge = (): ReactNode => {
    const { hasPermission } = useEmployee();
    const canView = hasPermission("view:pending-intake");
    const { data } = useFetchPendingLeads(canView);

    if (!canView) {
        return null;
    }

    const count = (data?.data ?? []).filter(
        (lead) => lead.status === "pending" && isOverSla(lead.receivedAt),
    ).length;

    if (count === 0) {
        return null;
    }

    const description = `${count} pending lead${count === 1 ? "" : "s"} over ${SLA_HOURS}h`;

    return (
        <Tooltip title={description}>
            <Chip
                size="small"
                color="error"
                icon={<TriangleAlert size={12} />}
                label={count}
                aria-label={description}
                sx={{ ml: 1, height: 20, "& .MuiChip-label": { px: 0.75 } }}
            />
        </Tooltip>
    );
};

export default PendingIntakeSlaBadge;
